export default "__VITE_ASSET__CrdXWmj$__"